



export abstract class BaseColor {
    public abstract toString(showAlpha?: boolean): string;
}